


















import { Component, Vue } from 'vue-property-decorator'
import { chatDeSuporteConfigurado } from '@/api/suporteChat'
import { abrirChatDeSuporte, contextoDaTela } from '@/store/vuex/suporte/ChatDeSuporteStore'

/**
 * Entrada do chat de suporte na barra de cada tela, no lugar do antigo botão do WhatsApp. O atributo
 * data-chat-suporte-icone é o alvo do destaque de novidade e de onde o painel encolhe ao fechar.
 */
@Component
export default class BotaoDoChatDeSuporte extends Vue {
	configurado = chatDeSuporteConfigurado()

	abrir() {
		abrirChatDeSuporte(contextoDaTela(this.$route))
	}
}
